module.exports = __webpack_public_path__ + "static/media/sridhar.d30c0a03.jpg";